import { type InvitationValidationResponse } from '@/interfaces/invitation';

import useReactQuery from '../common/useReactQuery';

const useValidateInvitation = (param: {
  invitationToken: string;
  enabled?: boolean;
}) => {
  const { invitationToken, enabled = true } = param;
  const { useQuery } = useReactQuery();

  return useQuery<InvitationValidationResponse>({
    queryKey: ['invitations', 'validate', invitationToken],
    url: `/api/school/parents/invitations/validate?invitation_token=${encodeURIComponent(invitationToken)}`,
    method: 'GET',
    enabled,
    retry: false,
  });
};

export default useValidateInvitation;
